import { MomentTime } from "app/components/Moment/Moment";
import { EventTimeHelper } from "app/helpers/eventTimeHelper";
import EventPhase from "app/screens/EventsScreen/components/EventPhase/EventPhase";
import type { EventIncidentType, EventType } from "app/types/eventType";
import React, { ClassType, Component } from "react";
import { injectIntl } from "react-intl";
import "./BaseballPhase.scss";

type Props = {
  eventData: EventType;
  intl: ClassType<Props, any, any>;
};

class BaseballPhase extends Component<Props> {
  parseEventPhase(eventPhase: string) {
    const { intl } = this.props;
    const inningStrings: string[] = eventPhase.split("_");
    const number: string = inningStrings[1];
    const position: string = inningStrings[2];
    return (
      <div className="baseball-phase__info">
        <span>
          {intl.formatMessage({
            id: `baseball-phase-${position.toLowerCase()}`,
          })}
          {` ${intl.formatMessage({ id: "bets-of" })} `}
        </span>
        <span>{EventTimeHelper.setOrdinalNumber(parseInt(number))}</span>
      </div>
    );
  }
  render() {
    const { eventData } = this.props;
    const eventIncidents: EventIncidentType[] = eventData?.eventIncidents || [];
    const eventPhase: string =
      eventIncidents.length > 0 ? eventIncidents[0].eventPhase : "";
    const isInningPhase: boolean = eventPhase.indexOf("INNING") > -1;

    if (
      !eventData ||
      !eventData.eventIncidents ||
      eventIncidents.length === 0
    ) {
      return null;
    }
    return isInningPhase ? (
      <div className="baseball-phase">{this.parseEventPhase(eventPhase)}</div>
    ) : (
      <React.Fragment>
        <EventPhase eventIncident={eventIncidents[0]} />
        <MomentTime
          value={eventIncidents[0].phaseStartDate}
          eventPhase={eventPhase}
          countDown
        />
      </React.Fragment>
    );
  }
}
export default injectIntl(BaseballPhase);
